import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/store";
import { toast } from "sonner";
import { LogoMark, LogoWordmark } from "@/components/Logo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(email, password); toast.success("Welcome back"); nav(loc.state?.from || "/"); }
    catch (err) { toast.error(err.response?.data?.detail || "Login failed"); }
    setLoading(false);
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8"><LogoMark size={32} /><LogoWordmark className="text-xl" /></div>
        <h1 className="font-display text-3xl font-bold mb-6">Sign in</h1>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" /></div>
          <div><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" /></div>
          <Button type="submit" className="btn-primary w-full h-11" disabled={loading} data-testid="login-submit">{loading ? "Signing in…" : "Sign in"}</Button>
        </form>
        <div className="flex items-center gap-3 my-6"><div className="flex-1 h-px bg-white/10" /><span className="text-xs text-muted-foreground">OR</span><div className="flex-1 h-px bg-white/10" /></div>
        <Button variant="outline" className="w-full h-11 border-white/15" onClick={googleLogin} data-testid="login-google">Continue with Google</Button>
        <p className="text-center text-sm text-muted-foreground mt-6">No account? <Link to="/signup" className="text-primary">Create one</Link></p>
      </div>
    </div>
  );
}
